module.exports = __webpack_public_path__ + "fonts/righthand-regularitalicdash-personal.26e080a8.ttf";